import React,{useEffect,useState,useContext} from "react";
import {Box,Button,IconButton} from '@mui/material'
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { VehicleHistoryContext } from "../Context/VehicleHistoryContext";
import Slider from '@mui/material/Slider';
export default function HistoryPlayControls({isLargeScreen}) {

	const vhContext = useContext(VehicleHistoryContext)
	const [leftPos,setLeftPos] = useState("calc(375px + ((100vw -  375px - 200px) / 2))")
	const [psText,setPsText] = useState("1X")


	useEffect(() => {
		if(isLargeScreen){
			setLeftPos("calc(375px + ((100vw -  375px - 400px) / 2))")
		}
		else{
			setLeftPos("calc((100vw - 250px) / 2)")
		}
	},[isLargeScreen])


	const onPlayButtonClicked = () => {

		let isPlaying = vhContext.isPlaying

		if(!isPlaying){
			vhContext.setIsPlaying(true)
		}else{
			vhContext.setIsPlaying(false)
		}
	}

	const onSliderChanged = (e) =>{

		vhContext.onSliderChanged(e.target.value)

	}

	const onButtonPlaySpeedClicked = (e) => {
		let ps = vhContext.playSpeed
		ps++

		if(ps > 5){
			ps =  1
		}

		vhContext.setPlaySpeed(ps)

		setPsText(ps + "X")
	}



	return (
		vhContext.isDataLoaded && (
		<Box style={{backgroundColor : "#f5f5f5", display:"flex", justifyContent : "center", alignItems : "center", width : isLargeScreen ? 400 : 250, position : "absolute", bottom : isLargeScreen ? 15 : "25px", zIndex : 50000, left: leftPos, padding : isLargeScreen ? "0.5rem" : "10px",borderRadius : 15, boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"}}>
			<IconButton size="small" onClick={() => {onPlayButtonClicked()}}>
				{ !vhContext.isPlaying ?
					(
						<PlayCircleIcon className="button-play-history" sx={{fontSize  : isLargeScreen ? "40px" : "30px"}} />
					)
					: <PauseCircleIcon className="button-pause-history" sx={{fontSize  : isLargeScreen ? "40px" : "30px"}} />
			}
			</IconButton>
			<Button onClick={(e) => {onButtonPlaySpeedClicked()} } size={isLargeScreen ? "large" : "medium"} sx={{minWidth : 0, marginRight : "4px"}} style={{color : "#673ab7"}}>
				{psText}
			</Button>
			<Slider
				style={{color : "#673ab7"}}
				sx={{margin : isLargeScreen ? "0.5rem" : "6px",}}
				aria-label="Steps"
				value={vhContext.coorIndex}
				valueLabelDisplay="auto"
				step={1}
				min={0}
				max={vhContext.coorPoints.length-1}
				onChange={(e)=> {onSliderChanged(e)}}
			>

			</Slider>

		</Box>
		)
	
	)
}